var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasOneEditableVueForm
    ? _c(
        "div",
        [
          _c("VueFormAttribute", {
            attrs: {
              definition: _vm.editableVueFormDefinition,
              attribute: _vm.editableVueFormAttribute
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default btn-outline-secondary mt-2",
                attrs: { disabled: _vm.saving },
                on: { click: _vm.saveVueForm }
              },
              [
                _vm.saving
                  ? _c("Spinner", { attrs: { small: true } })
                  : _vm._e(),
                _vm._v("\n      " + _vm._s(_vm.$t("btnSave")) + "\n    ")
              ],
              1
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }